import script from "./PageControls.vue?vue&type=script&setup=true&lang=js"
export * from "./PageControls.vue?vue&type=script&setup=true&lang=js"

import "./PageControls.vue?vue&type=style&index=0&id=1d5907b2&lang=sass&scoped=true"

import exportComponent from "/home/goran/projects/plodine/plodine/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d5907b2"]])

export default __exports__